import { useLayoutEffect, useState } from "react";

// The height left for a table's scrolling body: the height of the area that holds the table,
// minus everything in the table around its body (header and borders). The area gets its size
// from the layout (flex), so the table fills whatever space the controls above it leave. antd's
// virtual table needs this as a number. There is no minimum here: a minimum would push the table
// past its area in a short window. The dialog's own minimum height limits the size instead.
// Returns a callback ref, so the observer follows the area when it mounts again.
export const useTableBodyHeight = () => {
    const [area, setArea] = useState(null);
    const [height, setHeight] = useState(300);

    useLayoutEffect(() => {
        if (!area) return undefined;
        const measure = () => {
            const table = area.querySelector(".ant-table-container");
            const body = area.querySelector(".ant-table-body, .ant-table-tbody-virtual-holder");
            const chrome = table && body ? table.offsetHeight - body.offsetHeight : 0;
            setHeight(Math.max(0, Math.floor(area.clientHeight - chrome)));
        };
        // Once now, before the first paint; the observer only reports at the next frame.
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(area);
        return () => observer.disconnect();
    }, [area]);

    return [setArea, height];
};
